module.exports = __webpack_public_path__ + "static/careerclinic.1426ab80.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/careerclinic.png
// module id = 1492
// module chunks = 19843951674672